import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.469 20H3.75a1.2 1.2 0 0 1-.89-.36 1.2 1.2 0 0 1-.36-.89q0-.531.36-.89.359-.36.89-.36h7.719l-2.344-2.344a1.17 1.17 0 0 1-.344-.86q0-.515.344-.89.375-.375.89-.375.516 0 .891.375l4.469 4.469q.187.187.266.406.078.219.078.469t-.078.469-.266.406l-4.5 4.5q-.375.375-.875.36a1.26 1.26 0 0 1-.875-.391 1.32 1.32 0 0 1-.36-.875q-.015-.5.36-.875zm7.062-7.5 2.344 2.344q.345.343.344.86 0 .515-.344.89-.375.375-.89.375-.516 0-.891-.375l-4.469-4.469a1.1 1.1 0 0 1-.266-.406 1.4 1.4 0 0 1-.078-.469q0-.25.078-.469.079-.219.266-.406l4.5-4.5q.375-.375.875-.36t.875.391q.344.375.36.875.015.5-.36.875L18.531 10h7.719q.531 0 .89.36.36.359.36.89t-.36.89-.89.36z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }